/**
 * Finds the index of the row given its InstanceKey in the given table
 * @param instanceKey to find
 * @param tableview to find it in
 * @returns the index of the row in the table
 */
export default function findIndexByInstanceKey(instanceKey, tableView) {
    return tableView.rowKeys.indexOf(instanceKey);
}
//# sourceMappingURL=findIndexByInstanceKey.js.map